import { MODALS } from 'common/domain/constants';
import { STATES } from 'common/domain/states';

class WarningRequestVacationController {

  constructor($state, $window) {
    'ngInject';
    this.state = $state;
    this.isMobileApp = $window.innerWidth < 1024;
  }

  $onInit() {
    this.modal = angular.element(MODALS.WARNING_REQUEST_VACATION);
    this.floatingActionButtons = this.getFloatingActionButtons();
  }

  openVacationModal() {
    this.vacationModal = angular.element(MODALS.VACATION);
    this.vacationModal.modal('show');
    this.dismissModal();
  }

  openVacationLink() {
    this.isMobileApp ? this.goToScheduleMobile() : this.openVacationModal();
  }

  hideModal() {
    this.modal.modal('hide');
  }

  dismissModal() {
    this.hideModal();
    this.onDismiss();
  }

  goToScheduleMobile(){
    this.hideModal();
    this.state.go(STATES.VACATIONS_ABSENCES.MY_VACATIONS_MOBILE);
  }

  getFloatingActionButtons() {
    return [
      {
        literal: 'VACATIONS_ABSENCES.WARNING_REQUEST_VACATION.BUTTON'
      }
    ];
  }

}

export default WarningRequestVacationController;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/components/modals/warningRequestVacation/warningRequestVacation.controller.js